module.exports = __webpack_public_path__ + "e46b8ac5f7be797c3228943dff4737d7.svg";